/**
 * URL Parameter Handler
 * Handles URL parameter extraction and image URL building for automatic image loading
 */
class UrlParameterHandler {
  /**
   * Get the 'source' parameter from the current URL
   * @returns {string|null} The source parameter value or null if not found
   */
  static getSourceParameter() {
    const urlParams = new URLSearchParams(window.location.search);
    const sourceParam = urlParams.get('source');
    console.log('[UrlParameterHandler] Source parameter from URL:', sourceParam);
    return sourceParam;
  }
  
  /**
   * Build the CDN image URL from the source parameter
   * @param {string} sourceParam - The source parameter value
   * @returns {string|null} The built image URL or null if sourceParam is invalid
   */
  static buildImageUrl(sourceParam) {
    if (!sourceParam || typeof sourceParam !== 'string') {
      console.warn('[UrlParameterHandler] Invalid source parameter:', sourceParam);
      return null;
    }
    
    const imageUrl = `https://letz.com.br/cdn/shop/files/${sourceParam}.jpg`;
    console.log('[UrlParameterHandler] Built image URL:', imageUrl);
    return imageUrl;
  }
  
  /**
   * Validate if an image exists at the given URL
   * @param {string} imageUrl - The image URL to validate
   * @returns {Promise<boolean>} True if image exists, false otherwise
   */
  static async validateImageExists(imageUrl) {
    if (!imageUrl) {
      console.warn('[UrlParameterHandler] No image URL provided for validation');
      return false;
    }
    
    try {
      console.log('[UrlParameterHandler] Validating image existence:', imageUrl);
      const response = await fetch(imageUrl, { 
        method: 'HEAD',
        cache: 'no-cache'
      });
      
      const exists = response.ok;
      console.log('[UrlParameterHandler] Image validation result:', {
        url: imageUrl,
        status: response.status,
        exists: exists
      });
      
      return exists;
    } catch (error) {
      console.error('[UrlParameterHandler] Error validating image:', error);
      return false;
    }
  }
  
  /**
   * Extract source parameter and build image URL in one step
   * @returns {Promise<string|null>} The validated image URL or null
   */
  static async getValidatedImageUrl() {
    const sourceParam = this.getSourceParameter();
    if (!sourceParam) return null;
    
    const imageUrl = this.buildImageUrl(sourceParam);
    if (!imageUrl) return null;
    
    const isValid = await this.validateImageExists(imageUrl);
    return isValid ? imageUrl : null;
  }
}

// Export the class for global use
window.UrlParameterHandler = UrlParameterHandler;